import dynamic from 'next/dynamic';
import { Product } from '@/types';
import { Fragment, HTMLAttributes } from 'react';
import classNames from 'classnames';

const Card = dynamic(() => import('@/components/shared/Card'));

interface Props extends HTMLAttributes<HTMLElement> {
    recommendations: Omit<Product, 'brand_name' | 'favorite'>[];
}

const RecommendationsList = ({ recommendations, ...props }: Props) => {
    return (
        <div className="wrapper">
            <ul className="list-unstyled cards-list product-cards-list">
                {recommendations
                    .sort((a, b) => {
                        if (a.price === 0 && b.price !== 0) {
                            return 1;
                        } else if (a.price !== 0 && b.price === 0) {
                            return -1;
                        } else {
                            return 0;
                        }
                    })
                    .map((item, i) => {
                        return (
                            <Fragment key={item.id}>
                                {i === 0 && (
                                    <li className="cards-list__item card-list-title">
                                        <div className="card-list-title__text h1">Вам может быть интересно</div>
                                    </li>
                                )}
                                <li
                                    className={classNames('cards-list__item', {
                                        'cards-list__item--wide': i === 3,
                                    })}
                                >
                                    <Card
                                        productId={item.id}
                                        slug={item.slug}
                                        cardName={item.name}
                                        price={item.price}
                                        materialName={item.material}
                                        state={item.state}
                                        images={item.images}
                                        reference={item.reference}
                                        diameter={item.diameter}
                                        isStandardForm={item.is_standard_form}
                                        size={item.size}
                                        accessories={item.accessories}
                                        productColor={item.color}
                                        type={item.type}
                                        params={item.params}
                                        insert={item.insert}
                                        width={i === 3 ? 'wide' : 'default'}
                                        categoryId={item.category_id}
                                        available={item.available}
                                    />
                                </li>
                            </Fragment>
                        );
                    })}
            </ul>
        </div>
    );
};

export default RecommendationsList;
